const AuthTextCollapsed = () => {
  const authTextCollapsed = document.querySelector(".auth__text-collapsed ");

  if (authTextCollapsed) {
    const expandBtn = authTextCollapsed.querySelector(".text-collapsed__expand-btn");
    const hideBtnHtml = `<button type="button" class="text-collapsed__hide-btn">hide</button>`;

    const paragraphs = [...authTextCollapsed.querySelectorAll("p")];
    const lastIndex = paragraphs.length - 1;
    const lastParagraph = paragraphs[lastIndex];

    if (expandBtn) {
      expandBtn.addEventListener("click", () => {
        authTextCollapsed.classList.add("expanded");
        authTextCollapsed.style.maxHeight = authTextCollapsed.scrollHeight + "px";
        lastParagraph.insertAdjacentHTML('beforeend', hideBtnHtml);
        const hideBtn = authTextCollapsed.querySelector(".text-collapsed__hide-btn");

        if (hideBtn) {
          hideBtn.addEventListener("click", () => {
            authTextCollapsed.classList.remove("expanded");
            authTextCollapsed.style.maxHeight = "32px";
            hideBtn.remove();
          });
        }
      });
    }
  }

}

export default AuthTextCollapsed;